import "./App.css";
import "./sticky-headers.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AlertProvider } from "./contexts/AlertContext";
import Home from "./pages/Home";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import ServicesManager from "./pages/ServicesManager";
import TestimonialsManager from "./pages/TestimonialsManager";
import SettingsManager from "./pages/SettingsManager";
import SchedulerCalendar from "./pages/SchedulerCalendar";
import ContentEditor from "./pages/ContentEditor";
import CountryServicesManager from "./pages/CountryServicesManager";
import CallbackMaster from "./pages/CallbackMaster";
import BlogsManager from "./pages/BlogsManager";
import AnnouncementsManager from "./pages/AnnouncementsManager";
import AnnouncementAutomation from "./pages/AnnouncementAutomation";
import AnalyticsManager from "./pages/AnalyticsManager";
import UserManagement from "./pages/UserManagement";
import RoleManagement from "./pages/RoleManagement";
import LeadManagement from "./pages/LeadManagement";
import ClientManagement from "./pages/ClientManagement";
import AgreementsManager from "./pages/AgreementsManager";
import ScoringRulesManager from "./pages/ScoringRulesManager";
import AssignmentRulesManager from "./pages/AssignmentRulesManager";
import DiagnosticsPage from "./pages/DiagnosticsPage";
import KnowledgeCenterManager from "./pages/KnowledgeCenterManager";
import LeadPullPage from "./pages/LeadPullPage";
import WorkflowManager from "./pages/WorkflowManager";
import TaskManagement from "./pages/TaskManagement";
import LeadPullSettings from "./pages/LeadPullSettings";
import AIFollowUpConfig from "./pages/AIFollowUpConfig";
import HelpCenter from "./pages/HelpCenter";
import One92Settings from "./pages/One92Settings";
import AboutOne92 from "./pages/AboutOne92";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import NewsletterManager from "./pages/NewsletterManager";
import ChatbotSettings from "./pages/ChatbotSettings";
import LiveChats from "./pages/LiveChats";
import IntegrationsManager from "./pages/IntegrationsManager";
import EmailManager from "./pages/EmailManagerNew";
import DataManagement from "./pages/DataManagement";
import SpinnerSettings from "./pages/SpinnerSettings";
import SmartToolSettings from "./pages/SmartToolSettings";
import CompanySettings from "./pages/CompanySettings";
import CompanySettingsTest from "./pages/CompanySettingsTest";
import ProposalsManager from "./pages/ProposalsManager";
import InvoicesManager from "./pages/InvoicesManager";
import CommunicationManager from "./pages/CommunicationManager";
import SourceMaster from "./pages/SourceMaster";
import BlogList from "./pages/BlogList";
import BlogDetail from "./pages/BlogDetail";
import ServiceDetail from "./pages/ServiceDetail";
import CompetitorPricing from "./pages/CompetitorPricing";
import PricingRules from "./pages/PricingRules";
import MarginManagement from "./pages/MarginManagement";
import PublicProposalApproval from "./pages/PublicProposalApproval";
import PublicAgreementApproval from "./pages/PublicAgreementApproval";
import PublicDocumentETA from "./pages/PublicDocumentETA";
import PublicPromoLanding from "./pages/PublicPromoLanding";
import PartnerPublicLead from "./pages/PartnerPublicLead";
import ApplyOnline from "./pages/ApplyOnline";
import VisaDetails from "./pages/VisaDetails";
import VisaApplicationForm from "./pages/VisaApplicationForm";
import AdminLayout from "./components/AdminLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import ClientLogin from "./pages/ClientLogin";
import ClientPortal from "./pages/ClientPortal";
import ClientProtectedRoute from "./components/ClientProtectedRoute";
import PartnerLogin from "./pages/PartnerLogin";
import PartnerPortal from "./pages/PartnerPortal";
import PartnerProtectedRoute from "./components/PartnerProtectedRoute";
import BusinessPartnerManager from "./pages/BusinessPartnerManager";
import MasterPartnerLogin from "./pages/MasterPartnerLogin";
import MasterPartnerSignup from "./pages/MasterPartnerSignup";
import MasterPartnerDashboard from "./pages/MasterPartnerDashboard";
import MasterPartnerPartners from "./pages/MasterPartnerPartners";
import MasterPartnerProfile from "./pages/MasterPartnerProfile";
import MasterPartnerCommissions from "./pages/MasterPartnerCommissions";
import MasterPartnerManager from "./pages/MasterPartnerManager";
import MasterPartnerCommissionManager from "./pages/MasterPartnerCommissionManager";
import MasterPartnerAgreement from "./pages/MasterPartnerAgreement";
import PartnerSignupReferral from "./pages/PartnerSignupReferral";
import MasterPartnerProtectedRoute from "./components/MasterPartnerProtectedRoute";
import { AuthProvider } from "./contexts/AuthContext";
import { ClientAuthProvider } from "./contexts/ClientAuthContext";
import { PartnerAuthProvider } from "./contexts/PartnerAuthContext";
import { MasterPartnerAuthProvider } from "./contexts/MasterPartnerAuthContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import { WebSocketProvider } from "./contexts/WebSocketContext";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import TrackingScriptInjector from "./components/TrackingScriptInjector";

function App() {
  return (
    <div className="App">
      <AlertProvider>
        <AuthProvider>
          <WebSocketProvider>
            <NotificationProvider>
              <ClientAuthProvider>
              <PartnerAuthProvider>
              <MasterPartnerAuthProvider>
              <BrowserRouter>
              <TrackingScriptInjector />
              <Routes>
                <Route path="/" element={<ApplyOnline />} />
                <Route path="/home" element={<Home />} />
                <Route path="/about-one92" element={<AboutOne92 />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/service/:serviceId" element={<ServiceDetail />} />
                <Route path="/login" element={<AdminLogin />} />
                <Route path="/client-login" element={<ClientLogin />} />
                <Route path="/blogs" element={<><Header /><BlogList /><Footer /></>} />
                <Route path="/blogs/:slug" element={<><Header /><BlogDetail /><Footer /></>} />
                
                {/* Public Approval Routes */}
                <Route path="/public/proposal/:token" element={<PublicProposalApproval />} />
                <Route path="/public/agreement/:token" element={<PublicAgreementApproval />} />
                <Route path="/public/welcome/eta/:token" element={<PublicDocumentETA />} />
                <Route path="/promo/:slug" element={<PublicPromoLanding />} />
                
                {/* Apply Online Routes */}
                <Route path="/apply-online" element={<ApplyOnline />} />
                <Route path="/apply/:slug" element={<VisaDetails />} />
                <Route path="/apply/:slug/form" element={<VisaApplicationForm />} />
                
                {/* Partner Portal Routes */}
                <Route path="/partner/login" element={<PartnerLogin />} />
                <Route path="/partner/lead/:slug" element={<PartnerPublicLead />} />
                <Route path="/partner/signup/:referralCode" element={<PartnerSignupReferral />} />
                <Route
                  path="/partner/dashboard"
                  element={
                    <PartnerProtectedRoute>
                      <PartnerPortal />
                    </PartnerProtectedRoute>
                  }
                />
                
                {/* Master Partner Portal Routes */}
                <Route path="/master-partner/login" element={<MasterPartnerLogin />} />
                <Route path="/master-partner/signup" element={<MasterPartnerSignup />} />
                <Route path="/master-partner/agreement/:token" element={<MasterPartnerAgreement />} />
                <Route
                  path="/master-partner/dashboard"
                  element={
                    <MasterPartnerProtectedRoute>
                      <MasterPartnerDashboard />
                    </MasterPartnerProtectedRoute>
                  }
                />
                <Route
                  path="/master-partner/partners"
                  element={
                    <MasterPartnerProtectedRoute>
                      <MasterPartnerPartners />
                    </MasterPartnerProtectedRoute>
                  }
                />
                <Route
                  path="/master-partner/commissions"
                  element={
                    <MasterPartnerProtectedRoute>
                      <MasterPartnerCommissions />
                    </MasterPartnerProtectedRoute>
                  }
                />
                <Route
                  path="/master-partner/profile"
                  element={
                    <MasterPartnerProtectedRoute>
                      <MasterPartnerProfile />
                    </MasterPartnerProtectedRoute>
                  }
                />
                <Route
                  path="/client-portal"
                  element={
                    <ClientProtectedRoute>
                      <ClientPortal />
                    </ClientProtectedRoute>
                  }
                />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute>
                      <AdminLayout />
                    </ProtectedRoute>
                  }
                >
                  <Route index element={<AdminDashboard />} />
                  <Route path="live-chats" element={<LiveChats />} />
                  <Route path="users" element={<UserManagement />} />
                  <Route path="roles" element={<RoleManagement />} />
                  <Route path="leads" element={<LeadManagement />} />
                  <Route path="clients" element={<ClientManagement />} />
                  <Route path="agreements" element={<AgreementsManager />} />
                  <Route path="lead-scoring" element={<ScoringRulesManager />} />
                  <Route path="lead-assignment" element={<AssignmentRulesManager />} />
                  <Route path="diagnostics" element={<DiagnosticsPage />} />
                  <Route path="knowledge-center" element={<KnowledgeCenterManager />} />
                  <Route path="lead-pull" element={<LeadPullPage />} />
                  <Route path="workflows" element={<WorkflowManager />} />
                  <Route path="tasks" element={<TaskManagement />} />
                  <Route path="lead-pull" element={<LeadPullSettings />} />
                  <Route path="ai-followup" element={<AIFollowUpConfig />} />
                  <Route path="help" element={<HelpCenter />} />
                  <Route path="scheduler" element={<SchedulerCalendar />} />
                  <Route path="callback-master" element={<CallbackMaster />} />
                  <Route path="announcements" element={<AnnouncementsManager />} />
                  <Route path="announcement-automation" element={<AnnouncementAutomation />} />
                  <Route path="analytics" element={<AnalyticsManager />} />
                  <Route path="services" element={<ServicesManager />} />
                  <Route path="country-services" element={<CountryServicesManager />} />
                  <Route path="blogs" element={<BlogsManager />} />
                  <Route path="testimonials" element={<TestimonialsManager />} />
                  <Route path="newsletter" element={<NewsletterManager />} />
                  <Route path="chatbot-settings" element={<ChatbotSettings />} />
                  <Route path="content" element={<ContentEditor />} />
                  <Route path="integrations" element={<IntegrationsManager />} />
                  <Route path="emails" element={<EmailManager />} />
                  <Route path="data-management" element={<DataManagement />} />
                  <Route path="spinner-settings" element={<SpinnerSettings />} />
                  <Route path="smart-tools-settings" element={<SmartToolSettings />} />
                  <Route path="company-settings" element={<CompanySettings />} />
                  <Route path="proposals" element={<ProposalsManager />} />
                  <Route path="invoices" element={<InvoicesManager />} />
                  <Route path="communications" element={<CommunicationManager />} />
                  <Route path="source-master" element={<SourceMaster />} />
                  <Route path="settings" element={<SettingsManager />} />
                  <Route path="one92-settings" element={<One92Settings />} />
                  <Route path="competitor-pricing" element={<CompetitorPricing />} />
                  <Route path="pricing-rules" element={<PricingRules />} />
                  <Route path="margin-management" element={<MarginManagement />} />
                  <Route path="partner-management" element={<BusinessPartnerManager />} />
                  <Route path="master-partner-management" element={<MasterPartnerManager />} />
                  <Route path="master-partner-commissions" element={<MasterPartnerCommissionManager />} />
                </Route>
              </Routes>
            </BrowserRouter>
            <Toaster />
            </MasterPartnerAuthProvider>
            </PartnerAuthProvider>
            </ClientAuthProvider>
          </NotificationProvider>
        </WebSocketProvider>
      </AuthProvider>
      </AlertProvider>
    </div>
  );
}

export default App;